import React from 'react'

export const ScienceClubView = () => {
  return (
    <div>Science Club View</div>
  )
}
